/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import styled from 'styled-components'
import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import LanguageSelector from './LanguageSelector'
import { flowRight } from 'lodash'
import withLocale from '../../providers/Locale/withLocale'
import { ComponentProps as LocaleProps } from '../../providers/Locale/withLocale'
import { fontSize, FontSizeProps } from 'styled-system'

interface Props extends ComponentProps, LocaleProps {
  height?: string;
  isEmbed?: boolean;
}

const Header = ({ congress, height, locale, isEmbed }: Props) => {
  let logoUrl, slogan

  if (isEmbed) {
    return null
  }

  if (!locale) {
    logoUrl = congress.LogoURL
    slogan = congress.Slogan
  } else {
    switch (locale.currentLanguage) {
      case 'es':
        logoUrl = congress.LogoURL
        slogan = congress.Slogan
        break
      case 'en':
        logoUrl = congress.LogoURL
        slogan = congress.Slogan
        break
    }
  }

  const logo = logoUrl ? (
    <Logo src={logoUrl} alt={congress.Name} height={70}/>
  ) : (
    <Name>{congress.Name}</Name>
  )

  const excludedCongresses = ['veterinario2019', 'sem-internacional-2019', 'sem-matematicas-2019', 'sem-icec-2019']

  return (
    <Container embed={isEmbed}>
      <Wrapper height={height}>
        <LogoContainer>
          {logo}
          <Slogan fontSize={[0, 1, 2]} color={congress.PrimaryColor}>{slogan}</Slogan>
        </LogoContainer>
        {excludedCongresses.indexOf(congress.Slug) === -1 && <LanguageSelector responsive={false} embed={isEmbed}/>}
      </Wrapper>
    </Container>
  )
}

const Container = styled.div<any>`
  width: 100%;
  position: fixed;
  background-color: #FFF;
  border-bottom: ${({ embed }) => !embed && '1px solid #f2f5f7'};
  z-index: 999;
  top: 0;
`

const Wrapper = styled.div<any>`
  width: 100%;
  max-width: 1500px;
  padding: 24px 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 auto;

  @media screen and (max-width: 900px) {
    padding: 12px 48px 24px;
  }

  ${({ height }) => `height: ${height};`}

  @media screen and (max-width: 610px) {
    height: 100px
  }
`

const LogoContainer = styled.div`
  text-align: center;
  font-size: 14px;
`

const Logo = styled.img<any>`
  max-width: calc(100vw - 20px);
  object-fit: contain;
  margin: 16px 0;

  @media screen and (max-width: 900px) {
    margin: 3px 0;
    height: 50px;
    width: auto;
  }
`

const Name = styled.h1`
  margin: 0;
  font-weight: 400;
`

const Slogan = styled.div<FontSizeProps & any>`
  text-align: center;
  font-weight: bold;

  @media screen and (max-width: 900px) {
    line-height: 13px;
  }

  ${fontSize}
  ${({ color }) => `color: ${color};`}
`

Header.defaultProps = {
  height: '40px',
}

export default flowRight([withCongress, withLocale])(Header)
